import React, { useState, useEffect } from 'react'
import { ProgressBar } from 'primereact/progressbar'
import { Card } from 'primereact/card'
import { Message } from 'primereact/message';
import useAxios from '../../hooks/useAxios'
import { useAuth } from '../../contexts/AuthContext'
import MsisdnSearch from '../../components/MsisdnSearch'

const Usrinf = () => {
  const { user } = useAuth();

  const { fetchData, response, loading } = useAxios()
  const [responseData, setResponseData] = useState(null)

  const handleSearch = (msisdn) => {
    setResponseData(null)
    fetchData({ method: 'get', url: "/api/usrinf", params: { key: "msisdn", value: msisdn } })
  }

  useEffect(() => {
    if (response) {     
      setResponseData(response)
    }
  }, [response])


  if (!user) return null

  return (
    <>
      <MsisdnSearch onSubmit={handleSearch} loading={loading} title="Местоположение абонента" description="Определение местоположения абонента по номеру MSISDN" />
      {responseData?.result === "fail" && <div className='px-3 mt-5'><Message severity="error" text={responseData.msg} className="w-full"></Message></div>}
      {loading && <div className="px-3 mt-5"><ProgressBar mode="indeterminate" style={{ height: '6px' }}></ProgressBar></div>}

      {responseData?.data &&
        <div className="px-3 mt-5">
          <Card>
            {Object.keys(responseData.data).map((key) => (
              <div key={key}>{key}: {responseData.data[key]}</div>
            ))}
          </Card>
        </div>
      }
    </>
  )
}

export default Usrinf